import React from 'react';

import { useAppSelector } from '@/App/hooks';
import { CookieConsentModal } from '@/components/layout/AppCookieConsent/CookieConsentModal';
import { COOKIE_POLICY_PATH } from '@/components/layout/AppCookieConsent/types';
import { selectAppConfig } from '@/features/config/selectAppConfig';
import { isValueContainArrayElementPart } from '@/helpers/isValueContainArrayElementPart';

export const AppCookieConsent: React.FC = () => {
  const { consentCookieName, consentCookieVersion } = useAppSelector(selectAppConfig);
  const { pathname } = window.location;

  if (!consentCookieName || !consentCookieVersion || isValueContainArrayElementPart([COOKIE_POLICY_PATH], pathname)) {
    return null;
  }

  return <CookieConsentModal />;
};
